// 环境配置
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// 从环境变量获取配置，如果没有则使用默认值
// 开发默认走 webpack-dev-server 端口 + /api，由 config-overrides.js 代理到后端
// 生产环境须为 https，否则在 HTTPS 站点会触发「混合内容」被浏览器拦截
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (isDevelopment ? 'http://127.0.0.1:3001/api' : 'https://osapi.pute.cn/api');

const WS_URL = process.env.REACT_APP_WS_URL || 
  (isDevelopment ? 'ws://127.0.0.1:3000' : 'wss://osapi.pute.cn');

const MQTT_URL = process.env.REACT_APP_MQTT_URL || 'ws://125.65.79.28:1883';

// 导出配置
const config = {
  API_BASE_URL,
  WS_URL,
  MQTT_URL,
  isDevelopment,
  isProduction,
  // 环境信息
  NODE_ENV: process.env.NODE_ENV,
  // 版本信息
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  // 时区配置
  SERVER_TIMEZONE: process.env.REACT_APP_SERVER_TIMEZONE || 'Asia/Shanghai',
};

export default config;
